/** Fallback Instant Quote widget button colour when an operator hasn't set one. */
export const DEFAULT_WIDGET_COLOR = "#5F3B6C";
